import { useMemo } from 'react'

/**
 * @param
 * reverse 将会使 flatItems 翻转
 */
const useSplitArray = <Item = any>(items: Item[], flatLen = 3, reverse = false) => {
  return useMemo(() => {
    const _items = reverse ? [...items] : items
    const flatten = _items.slice(0, flatLen)
    const flatItems = reverse ? flatten.reverse() : flatten
    const dropdownItems = _items.slice(flatLen)
    if (dropdownItems.length === 1) return [flatItems.concat(dropdownItems), []]
    return [flatItems, dropdownItems]
  }, [items, flatLen, reverse])
}

export default useSplitArray
